import { createGlobalStyle } from 'styled-components';
import { fonts, colors } from '@eriksdigital/atomic-ui/styles';
import './fontface.css';
/*Font face keeps re rendering if added to global styles which is a known issue with styled components and to fix that issue we need to add font face to a separate css file and import it here. Issue link https://github.com/styled-components/styled-components/issues/2227*/

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: Geomanist, Arial, sans-serif;
    font-weight: ${fonts.fontWeight.normal};
    min-width: 1000px;
    font-size: 14px;
  }

  .bold-style {
    font-family: GeomanistBold, Arial, sans-serif;
    font-weight: ${fonts.fontWeight.normal};
  }

  body,
  p,
  ul,
  h1,
  h2,
  h3,
  h4,
  h5,
  fieldset,
  label {
    margin: 0;
    padding: 0;
  }

  ul {
    list-style-type: none;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  fieldset {
    border: none;
  }

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }

  select {
    appearance: none;
    background-image: none;
    background: transparent;
  }

  select::-ms-expand {
    visibility: hidden;
  }

  *::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    background: ${colors.default.gray};
    border-radius: 8px;
    height:30px;
  }
  
  *::-webkit-scrollbar-track-piece {
     display:none;
  }
  
  #root {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  .tooltiptext {
    width: 300px !important;
  }

  .highlight {
    background-color: #ffac004d;
  }

  .first-letter-uppercase::first-letter {
    text-transform: capitalize;
  }

  .first-letter-uppercase{ display: inline}
`;

export default GlobalStyles;
